import {
  FontSizes,
  vs,
  WINDOW_HEIGHT,
  WINDOW_WIDTH,
} from '../../Utils/Dimensions';

import CCColors from '../../Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  logo: {
    width: 140,
    height: 38,
    resizeMode: 'contain',
  },
  formHalf: {
    margin: 'auto',
    marginTop: '5%',
    padding: vs(64),
  },
  formHalfMobile: {
    marginTop: 0,
    backgroundColor: CCColors.CCTableBg,
    position: 'relative',
    overflow: 'hidden',
  },
  // Brown hero band, edge-to-edge across the top of the mobile column —
  // holds only the carousel, rounded off at the bottom like a banner.
  mobileHeroBrown: {
    width: '100%',
    backgroundColor: CCColors.Login.Ink,
    borderBottomLeftRadius: 32,
    borderBottomRightRadius: 32,
    position: 'relative',
    overflow: 'hidden',
    alignItems: 'center',
    paddingTop: vs(28),
    paddingBottom: vs(24),
    paddingHorizontal: vs(16),
  },
  // Cream body below the hero — logo, instruction, form fields, terms.
  mobileBody: {
    flex: 1,
    position: 'relative',
    padding: vs(20),
    paddingTop: vs(28),
  },
  mobileLogo: {
    width: 128,
    height: 26,
    resizeMode: 'contain',
    alignSelf: 'center',
    marginBottom: 20,
  },
  testimonialSection: {
    justifyContent: 'space-evenly',
  },
  heroHeadline: {
    fontSize: 30,
    fontWeight: 'bold',
    lineHeight: 37,
    textAlign: 'center',
    color: CCColors.Login.Ink,
    marginTop: 16,
  },
  heroSupport: {
    fontSize: 13,
    textAlign: 'center',
    color: CCColors.Login.Label,
    marginTop: 10,
  },
  otpHeadline: {
    fontSize: 20,
    fontWeight: 'bold',
    color: CCColors.Login.Ink,
    textAlign: 'center',
  },
  otpSubline: {
    fontSize: 13,
    color: CCColors.Login.Label,
    textAlign: 'center',
    marginTop: 6,
  },
  pillRow: {
    borderWidth: 1,
    borderColor: CCColors.Login.Border,
    borderRadius: 14,
    backgroundColor: CCColors.White,
    // No overflow:'hidden' here — it clips CCTextInput's floating label
    // animation, leaving the placeholder stuck overlapping the typed value.
  },
  pillDivider: {
    width: 1,
    alignSelf: 'stretch',
    marginVertical: 8,
    backgroundColor: CCColors.Login.Border,
  },
  pillSelect: {
    width: 130,
    height: 48,
    borderColor: 'transparent',
    backgroundColor: 'transparent',
  },
  pillInput: {
    flex: 1,
    width: 'auto',
    height: 48,
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  adminInputBox: {
    borderWidth: 1,
    borderColor: CCColors.Login.Border,
    borderRadius: 14,
    backgroundColor: CCColors.White,
  },
  adminInput: {
    flex: 1,
    width: 'auto',
    height: 48,
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  otpBox: {
    width: 44,
    height: 52,
    borderWidth: 1,
    borderColor: CCColors.Login.Border,
    borderRadius: 10,
    textAlign: 'center',
    fontSize: 20,
    color: CCColors.Login.Ink,
    outline: 'none',
  },
  errorText: {
    fontSize: 13,
    color: CCColors.Red,
    textAlign: 'center',
    marginBottom: 10,
    paddingHorizontal: 16,
  },
  termsRow: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonStyles: {
    fontSize: FontSizes[14],
    fontWeight: '600',
    color: CCColors.Login.Ink,
  },
  buttonWrapper: {
    backgroundColor: CCColors.Login.Gold,
    borderRadius: 14,
    width: 380,
    margin: 'auto',
    shadowColor: CCColors.Login.GoldDeep,
    shadowOpacity: 0.35,
    shadowRadius: 12,
    shadowOffset: {width: 0, height: 6},
    elevation: 4,
  },
  buttonWrapperMobile: {
    width: '100%',
  },
  // Unused since "Change number" became a text link (see changeNumberLink
  // below); kept for any future secondary button on this screen.
  outlineButtonWrapper: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: CCColors.Login.Border,
    borderRadius: 14,
    width: 170,
  },
  // "Change number" on the OTP step: a plain text link, deliberately NOT a
  // button — it's the escape hatch, and a bordered pill beside Verify OTP made
  // the two read as equal-weight choices.
  changeNumberLink: {
    alignSelf: 'center',
    paddingVertical: 4,
    paddingHorizontal: 6,
    cursor: 'pointer',
  },
  changeNumberLinkHovered: {
    opacity: 0.7,
  },
  changeNumberText: {
    color: CCColors.Login.Label,
    textDecorationLine: 'underline',
  },
  outlineButtonWrapperMobile: {
    width: '48%',
  },
  // Full-bleed split layout — the two panels stretch to fill the entire
  // viewport (no bounded/centered card).
  container: {
    height: WINDOW_HEIGHT,
    width: WINDOW_WIDTH,
  },
  textBoxes: {
    height: 48,
    flex: 0.85,
    width: vs(320),
    borderRadius: 8,
    borderColor: CCColors.TextBoxes.Borders,
    borderWidth: 1,
  },
  textHeaders: {
    color: CCColors.TextColor.Primary,
    fontSize: 24,
  },
  rightlabelText: {
    paddingLeft: vs(120),
    flex: 0.5,
    marginTop: '6%',
  },
  sidePanelDesktop: {
    width: '40%',
    minWidth: 340,
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: CCColors.Login.Ink,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  sidePanelPattern: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    opacity: 0.4,
    resizeMode: 'cover',
  },
  sidePanelInner: {
    width: '100%',
    // Fill nearly the entire panel width — no more capping to a narrow
    // column, which left large empty gutters on the left/right.
    maxWidth: 560,
    // Left-aligned column — logo, headline, carousel card and USP row all
    // share the same left edge instead of the card/USPs floating centered
    // under left-aligned text.
    alignItems: 'flex-start',
  },
  sidePanelLogo: {
    width: 170,
    height: 34,
    resizeMode: 'contain',
    alignSelf: 'flex-start',
    marginBottom: 36,
  },
  sidePanelHeadlineBlock: {
    alignSelf: 'flex-start',
    marginBottom: 28,
  },
  sidePanelHeadline: {
    fontSize: 42,
    lineHeight: 46,
    color: CCColors.White,
    textAlign: 'left',
  },
  sidePanelSupport: {
    fontSize: 17,
    color: CCColors.Login.CardBg,
    marginTop: 14,
    lineHeight: 25,
    textAlign: 'left',
    maxWidth: 520,
  },
  uspRow: {
    justifyContent: 'flex-start',
    marginTop: 40,
    flexWrap: 'wrap',
  },
  uspItem: {
    alignItems: 'flex-start',
    width: 130,
  },
  uspIconCircle: {
    width: 60,
    height: 60,
    borderRadius: 100,
    backgroundColor: 'rgba(255,255,255,0.1)',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
  },
  uspLabel: {
    fontSize: 14,
    color: CCColors.Login.CardBg,
    textAlign: 'left',
    lineHeight: 18,
  },
  formPanelDesktop: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 48,
    backgroundColor: CCColors.CCTableBg,
    position: 'relative',
    overflow: 'hidden',
  },
  formPanelPattern: {
    position: 'absolute',
    bottom: -60,
    right: -60,
    width: 260,
    height: 260,
    opacity: 0.3,
    resizeMode: 'contain',
  },
  formCardDesktop: {
    width: 720,
    maxWidth: '100%',
    backgroundColor: CCColors.White,
    borderRadius: 32,
    borderWidth: 1,
    borderColor: CCColors.Login.Border,
    padding: 64,
    shadowColor: CCColors.Login.Ink,
    shadowOpacity: 0.08,
    shadowRadius: 8,
    shadowOffset: {width: 0, height: 2},
    elevation: 2,
  },
  formCardLogo: {
    width: 170,
    height: 34,
    resizeMode: 'contain',
    marginBottom: 32,
    // Centred to match the headline/support copy under it (and the mobile logo,
    // which was already centred) — left-aligned it read as a stray header.
    alignSelf: 'center',
  },
  icon: {
    height: 35,
    width: 35,
    color: CCColors.BlueAqua,
  },
  modal: {
    backgroundColor: 'white',
    zIndex: 5,
    overflow: 'hidden',
    bottom: 0,
    width: '100%',
    maxHeight: '80%',
    position: 'absolute',
  },
});
